import Typography from '@mui/material/Typography';
import StringHelper from '../../helpers/string.helper';
import { InformationSectionProps } from '../../interfaces/props/InformationSectionProps';
import { useMemo } from 'react';

const NO_INFO_MESSAGE = '- No Information is available';

const InformationSection = ({ title, content, biggerFont }: InformationSectionProps) => {
  const renderTitle = useMemo(() => {
    return <Typography className={biggerFont ? 'h4' : 'h6'} gutterBottom>
      {title}
    </Typography>
  }, [title, biggerFont]);

  if (0 < content.length) {
    const processedContent = content.split(/\n/).map((detail) => {
      return detail.replace(/[.,!?]$/, '');
    });

    return (
      <>
        {renderTitle}
        {processedContent.map((detail) => (
          <Typography key={StringHelper.generateRandomString(10)} className={biggerFont ? 'ps-2' : 'text-label'}>
            {detail}
          </Typography>
        ))}
      </>
    );
  }

  return <>
    {renderTitle}
    <Typography className={biggerFont ? 'ps-2' : 'text-label'}>
      {NO_INFO_MESSAGE}
    </Typography>
  </>
};

export default InformationSection;
